import { memo } from 'react'
import {
  InformationCircleIcon,
  PhoneIcon, EnvelopeIcon, GlobeAltIcon, HeartIcon
} from '@heroicons/react/24/outline'

/**
 * EntityMoreInfoSection - Contact details and description for an entity.
 * Renders inline (no accordion) — intended for use inside the Info tab.
 * @atomic @idempotent
 */
const EntityMoreInfoSection = memo(function EntityMoreInfoSection({ entityDetails, t }) {
  const { description, phone, email, website, tipUrl } = entityDetails

  if (!description && !phone && !email && !website && !tipUrl) return null

  return (
    <div>
      <div className="flex items-center gap-1.5 mb-2">
        <InformationCircleIcon className="w-4 h-4 text-primary flex-shrink-0" />
        <span className="text-xs font-semibold text-gray-700">{t('entity.moreInfo', 'More info')}</span>
      </div>
      <div className="space-y-1.5">
        {description && (
          <p className="text-xs text-gray-600 leading-snug mb-1.5">{description}</p>
        )}
        {phone && (
          <a href={`tel:${phone}`} className="flex items-center gap-1.5 text-xs text-gray-700 hover:text-primary transition-colors bg-gray-50 rounded-lg p-1.5">
            <PhoneIcon className="w-3.5 h-3.5 flex-shrink-0 text-primary" /><span>{phone}</span>
          </a>
        )}
        {email && (
          <a href={`mailto:${email}`} className="flex items-center gap-1.5 text-xs text-gray-700 hover:text-primary transition-colors bg-gray-50 rounded-lg p-1.5">
            <EnvelopeIcon className="w-3.5 h-3.5 flex-shrink-0 text-primary" /><span className="break-all">{email}</span>
          </a>
        )}
        {website && (
          <a href={website.startsWith('http') ? website : `https://${website}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 text-xs text-gray-700 hover:text-primary transition-colors bg-gray-50 rounded-lg p-1.5">
            <GlobeAltIcon className="w-3.5 h-3.5 flex-shrink-0 text-primary" /><span className="break-all">{website}</span>
          </a>
        )}
        {tipUrl && (
          <a href={tipUrl.startsWith('http') ? tipUrl : `https://${tipUrl}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 text-xs text-primary font-medium hover:text-primary/80 transition-colors bg-primary/10 border border-primary/20 rounded-lg p-1.5">
            <HeartIcon className="w-3.5 h-3.5 flex-shrink-0 text-primary" />
            <span>{t('entities.entity.tipUrl', 'Support them')}</span>
          </a>
        )}
      </div>
    </div>
  )
})

export default EntityMoreInfoSection
